import {useConstructorEnvironment} from "./useConstructorEnvironment";
import {ConstructorEnvironment} from "../data";

export const useConstructorSubmitText = () => {
    const constructorEnvironment = useConstructorEnvironment();

    switch (constructorEnvironment) {
        case ConstructorEnvironment.gameboxAdmin:
            return 'Сохранить';

        case ConstructorEnvironment.presetAdmin:
            return 'Применить';

        case ConstructorEnvironment.cart:
        default:
            return 'В корзину';
    }
};
